import { render, staticRenderFns } from "./SpecificHealthExamTable.vue?vue&type=template&id=3c847da0&scoped=true"
import script from "./SpecificHealthExamTable.vue?vue&type=script&lang=js"
export * from "./SpecificHealthExamTable.vue?vue&type=script&lang=js"
import style0 from "./SpecificHealthExamTable.vue?vue&type=style&index=0&id=3c847da0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c847da0",
  null
  
)

export default component.exports